module.exports = __webpack_public_path__ + "static/img/card_06@2x.0a7cf76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card_06@2x.png
// module id = 9F3D
// module chunks = 0